import React from 'react';

const AdminListToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filters = [],
  shownCount,
  totalCount,
  t,
  onClear,
  showClear = false
}) => (
  <div className="admin-list-toolbar">
    <div className="admin-list-toolbar-row">
      <label className="admin-search">
        <span className="admin-search-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
          </svg>
        </span>
        <input
          type="search"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder || t('searchPlaceholder')}
          autoComplete="off"
        />
      </label>
      {filters.map((filter) => (
        <label key={filter.id} className="admin-filter">
          <span className="admin-filter-label">{filter.label}</span>
          <select
            value={filter.value}
            onChange={(e) => filter.onChange(e.target.value)}
          >
            {filter.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ))}
      {showClear && (
        <button type="button" className="admin-clear-filters" onClick={onClear}>
          {t('clearFilters')}
        </button>
      )}
    </div>
    <p className="admin-list-count">
      {t('showingCount')
        .replace('{shown}', String(shownCount))
        .replace('{total}', String(totalCount))}
    </p>
  </div>
);

export default AdminListToolbar;
